import { render } from "./patient-content.vue?vue&type=template&id=76452441"
import script from "./patient-content.vue?vue&type=script&lang=js"
export * from "./patient-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__